import PropTypes from 'prop-types';
import React from 'react';
import mapContextToProps from 'react-context-toolbox/mapContextToProps';
import { FormattedMessage } from 'react-intl';

import { AuthContext } from '../components/AuthWrapper';
import ContactCardFooter from '../components/ContactCardFooter';
import PageRoot from '../components/PageRoot';
import PageSegment from '../components/PageSegment';

const propTypes = {
  logout: PropTypes.func.isRequired,
};

class NoReservationPage extends React.Component {
  componentDidMount() {
    const { logout } = this.props;

    logout();
  }

  render() {
    return (
      <PageRoot theme="light" noFooter>
        <PageSegment theme="dark" align="center">
          <PageSegment.Heading>
            <FormattedMessage
              id="noReservation.heading"
              defaultMessage="Oops looks like you don't have a reservation"
            />
          </PageSegment.Heading>
          <ContactCardFooter />
        </PageSegment>
      </PageRoot>
    );
  }
}

NoReservationPage.propTypes = propTypes;

export default mapContextToProps(
  AuthContext,
  ({ logout }) => ({ logout }),
  NoReservationPage,
);
